import '@/registerServiceWorker';

import { createApp } from 'vue';
import appData from '@/common/modules/appData';
import sentry from '@/common/modules/sentry';
import router from './router';
import LearnLogin from './LearnLogin.vue';

createApp(LearnLogin).use(sentry, { appType: 'learn' }).use(appData).use(router).mount('#app');
